import './ClientScreen.scss';

import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Helmet } from 'react-helmet';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { isWhitelabel } from 'src/utils/utils';


import ClientPropertiesForm from './ClientPropertiesForm';
import FacilityImageUpload from 'src/component/UI/FacilityImageUpload';

import { getClient } from 'src/module/authentication/selector';
import { fetchClient } from 'src/module/authentication/action';
import UsersList from 'src/component/UsersList';

export default function ClientScreen () {
  const dispatch = useDispatch();

  const client = useSelector(getClient);
  useEffect(() => {
    dispatch(fetchClient());
  }, []);

  const title = isWhitelabel() ? 'ATCOM' : 'SmartTrace';

  return (
    <div className='page' id="client" data-testid='client-screen'>
      <Helmet>
        <title>{title} - Facility Details</title>
      </Helmet>

      <h2>Facility Details</h2>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Paper>
            <ClientPropertiesForm />
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper>
            <FacilityImageUpload />
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper>
            <h2>Users</h2>
            <UsersList client={client} />
          </Paper>
        </Grid>
      </Grid>

    </div>
  );
}
